/**
 * `pending-slo-dashboard` v0 — Zod contracts.
 */

import { z } from 'zod';

export const SloMinuteRollupRowSchema = z.object({
  route: z.string(),
  minute: z.string(),
  reqCount: z.number().int().nonnegative(),
  errCount: z.number().int().nonnegative(),
  p95Ms: z.number().int().nonnegative(),
});
export type SloMinuteRollupRow = z.infer<typeof SloMinuteRollupRowSchema>;

export const SloRouteAggregateSchema = z.object({
  route: z.string(),
  windowDays: z.number().int().positive(),
  reqCount: z.number().int().nonnegative(),
  errCount: z.number().int().nonnegative(),
  /** 1 - errCount/reqCount. Returned as 1 when reqCount=0. */
  availability: z.number().min(0).max(1),
  /** p95 of the bucket p95s (approximation). */
  p95Ms: z.number().int().nonnegative(),
  /** Burn rate over the window — error budget consumed per hour. */
  burnRatePerHour: z.number(),
  /** Operator-set SLO target (default 99.5%). */
  sloTarget: z.number().min(0).max(1),
});
export type SloRouteAggregate = z.infer<typeof SloRouteAggregateSchema>;

export const SloDashboardResponseSchema = z.object({
  windowDays: z.number().int().positive(),
  generatedAt: z.string(),
  routes: z.array(SloRouteAggregateSchema),
});
export type SloDashboardResponse = z.infer<typeof SloDashboardResponseSchema>;

export const SloRouteSparkSchema = z.object({
  route: z.string(),
  windowMinutes: z.number().int().positive(),
  buckets: z.array(SloMinuteRollupRowSchema),
});
export type SloRouteSpark = z.infer<typeof SloRouteSparkSchema>;
